// extracted by mini-css-extract-plugin
export default {"mt":"UserAgreementView_mt__K80I+"};